<template>
  <div>
    <van-popup
      v-model="isShow"
      position="right"
      lock-scroll
      close-on-popstate
      :style="{ height: '100%', width:'100%' }"
    >
      <ld-header
        @click-left="isShow = false"
        @click-right="complie"
      >
        <span
          slot="right"
          class="main-color"
        >
          {{ $t('B010','保存') }}
        </span>
      
        编辑个人信息
      </ld-header>
    
      <van-cell-group>
        <van-field
          :label="$t('D039','英文姓名')"
          placeholder="请输入英文姓名"
          v-model="engName"
          input-align="left"
          clearable
        />
      </van-cell-group>
    </van-popup>
  </div>
</template>

<script>
import mixin from './mixin'

export default {
  name: 'EditEngName',
  mixins: [mixin],
  data() {
    return {
      engName: ''
    }
  },
  created () {
    this.engName = this.empInfo.engName
  },
  methods: {
    complie () {
      this.empInfo.engName = this.engName
      this.save()
    }
  }
}
</script>